module.exports = __webpack_public_path__ + "img/lmdc-web-bg.80703269.png";